import React, { useEffect, useState } from "react";
import { useFieldArray } from "react-hook-form";
import IconBtn from "../../../form/icon-btn";
import { AccordionDropDownIcon, AccordionDropUpIcon, AddNewScreenIcon, DeleteIcon } from "../../../svg";
import { InputField, TextAreaField } from "../../../form/input-fields";
import MachineFields from "../custom-hierarchy-master-form";
import IconTextBtn from "../../../form/icon-text-btn";

const SegmentFields = ({ control, register, errors, headerDetails }: any) => {

  const [additionalDetails, setAdditionalDetails] = useState({});

  const { fields, append, remove } = useFieldArray({
    control,
    name: "segmentDetails",
  });

  useEffect(() => {
    if (headerDetails?.additionalDetails) {
      try {
        const parsed = JSON.parse(headerDetails.additionalDetails);
        setAdditionalDetails(parsed);
      } catch (e) {
        console.error("Failed to parse additionalDetails:", e);
      }
    }
  }, [headerDetails]);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleAccordion = (index: number) => {
    setOpenIndex(prev => (prev === index ? null : index));
  };

  return (
    <div className="w-full mb-6">
      <div className="flex justify-between items-center mb-3">
        <label className="text-[1.8rem] font-medium rounded-[0.3rem]">Segments</label>
        <IconTextBtn
          icon={<AddNewScreenIcon />}
          label="Add Segment"
          btnSize="large"
          handleClick={() => append({ segmentName: "", machineDetails: [] })}
        />
      </div>

      {fields.map((field: any, index: number) => {
        const isOpen = openIndex === index;
        return (
          <div key={field.id} className="mb-5 border border-gray-300 rounded-md">
            {/* Accordion Header */}
            <div
              onClick={() => toggleAccordion(index)}
              className="flex justify-between items-center bg-gray-100 cursor-pointer p-4 rounded-t-md"
            >
              <span className="text-[1.2rem] font-medium rounded-[0.3rem]">Segment {index + 1}</span>
              <span>{isOpen ? <AccordionDropUpIcon /> : <AccordionDropDownIcon />}</span>
            </div>

            {isOpen && (
              <div className="p-4 border-t border-gray-300">
                <div className="flex items-center gap-2 mb-3">
                  <div className="flex-1">
                    <InputField
                      labelName={`Segment ${index + 1}`}
                      type="text"
                      id={`segmentDetails.${index}.segmentName`}
                      isRequired={true}
                      formHandle={register(`segmentDetails.${index}.segmentName`, {
                        required: "Segment name is required",
                      })}
                      error={errors?.segments?.[index]?.name?.message}
                    />
                  </div>
                  <button type="button" className="text-red-500 hover:text-red-700">
                    <IconBtn
                      icon={<DeleteIcon />}
                      size="w-[1.6rem]"
                      handleClick={() => remove(index)}
                    />
                  </button>
                </div>

                <div className="flex-1 mb-3" style={{ display: (additionalDetails as any)?.hideSegmentDetails?.ip === 1 ? "none" : "block", }}>
                    <InputField
                      labelName={`IP ${index + 1}`}
                      type="text"
                      id={`segmentDetails.${index}.ip`}
                      isRequired={true}
                      formHandle={register(`segmentDetails.${index}.ip`, {
                        required: "IP is required",
                      })}
                      error={errors?.segments?.[index]?.name?.message}
                    />
                  </div>
                  <div className="flex-1 mb-3" style={{ display: (additionalDetails as any)?.hideSegmentDetails?.port === 1 ? "none" : "block", }}>
                    <InputField
                      labelName={`Port ${index + 1}`}
                      type="text"
                      id={`segmentDetails.${index}.port`}
                      isRequired={true}
                      formHandle={register(`segmentDetails.${index}.port`, {
                        required: "Port is required",
                      })}
                      error={errors?.segments?.[index]?.name?.message}
                    />
                  </div>

                  <div className="flex-1 mb-3" style={{ display: (additionalDetails as any)?.hideSegmentDetails?.indicators === 1 ? "none" : "block", }}>
                    <TextAreaField
                      labelName={`Indicators ${index + 1}`}
                      type="text"
                      id={`segmentDetails.${index}.indicators`}
                      isRequired={true}
                      formHandle={register(`segmentDetails.${index}.indicators`, {
                        required: "indicators  is required",
                      })}
                      error={errors?.segments?.[index]?.name?.message}
                    />
                  </div>
                {/* Nested MachineFields */}
                <MachineFields
                  nestIndex={index}
                  control={control}
                  register={register}
                  errors={errors}
                  headerDetails={headerDetails}
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default SegmentFields;